import classcat from "classcat";
import React from "react";

import { Image } from "@touchtech/baselayer-ui";
import { IconRight } from "@touchtech/web-baselayer-ui";

import { Logo } from "@is/components/Logo";
import { SupportedTenants } from "@is/constants/bestseller";
import { getEnvValue } from "@is/utils/env";

import css from "./BestsellerTenants.module.css";
import useManageBestsellerTenants from "./hooks/useManageBestsellerTenants";

const environment = getEnvValue("VITE_ENVIRONMENT");
const TENANT_ROW_HEIGHT = 129;

const BestsellerTenants = () => {
  const { t, handleTenantSelectionClick } = useManageBestsellerTenants();

  return (
    <div className={css.container}>
      <div className={classcat(["text-display-6xl", css.title])}>
        {t("Select the brand")}
      </div>
      <div
        className={css.tenants}
        style={{
          height:
            TENANT_ROW_HEIGHT *
            Math.floor(window.screen.height / 2 / TENANT_ROW_HEIGHT),
        }}
      >
        {SupportedTenants[environment].map((tenant) => (
          <div
            key={tenant.id}
            data-id={tenant.id}
            className={classcat(["text-headline-5xl", css.link])}
            onClick={handleTenantSelectionClick}
          >
            <div></div>
            <div className={css.logoContainer}>
              {tenant.logoUrl ? (
                <div className={css.logo}>
                  <Image
                    layout="stretchHorizontally"
                    src={tenant.logoUrl}
                    alt={tenant.name}
                  />
                </div>
              ) : (
                <div className={classcat(["text-display-6xl", css.brandName])}>
                  {tenant.name}
                </div>
              )}
            </div>
            <div className={css.arrowContainer}>
              <IconRight className="text-label-3xl" />
            </div>
          </div>
        ))}
      </div>
      <Logo className={css.footer} showLogo={false} />
    </div>
  );
};

export default BestsellerTenants;
